import { useAppContext } from "../../app/components/App/AppProvider.tsx";

export default function GetTitleForProche(): string {
  const { user }: any = useAppContext();

  const {
    isProcheBd,
    isProcheCapsulesVideo,
    isProcheRealiteVirtuelle,
    isProcheFinDeVie,
  }: any = user;
  if (isProcheBd) {
    return "Mes bandes dessinées";
  } else if (isProcheCapsulesVideo) {
    return "Mes vidéos";
  } else if (isProcheRealiteVirtuelle) {
    return "Réalité virtuelle";
  } else if (isProcheFinDeVie) {
    return "Mes ressources";
  } else {
    //TODO pour la prod mettre un vrai message
    return "Par défaut";
  }
}
